import React, { useState, useEffect } from 'react';
import { makeStyles } from '@mui/styles';
import {
    Box, Container, Grid,
    Pagination, Typography, CircularProgress
} from '@mui/material';

import RequestUtils from 'modules/api/RequestUtils';
import useSnackbar from 'hooks/useSnackbar';
import { ChallengeCard, Toolbar } from './components';
import Page from 'components/Page';

const useStyles = makeStyles((theme) => ({
    root: {
        backgroundColor: theme.palette.background.dark,
        minHeight: '100%',
        paddingBottom: theme.spacing(3),
        paddingTop: theme.spacing(3)
    },
    challengeCard: {
        height: '100%',
    }
}));

function ChallengersList() {
    const classes = useStyles();
	const snackbar = useSnackbar();
    const [awaitData, setAwaitingData] = useState(false);
    const [arrayChallenges, setArrayChallenges] = useState([]);
    const [inputValue, setInputValue] = useState('');
    const [pagedObject, setPagedObject] = useState({
        searchTerm: '',
        page: 1,
        itensPerPage: 12,
        challengeIsActive: true,
        amountPage: 1
    });

    function componentMount() {
        handlePagedChallenges(pagedObject);
    }
    useEffect(componentMount, []);

    async function handlePagedChallenges(pagedObject) {
        setAwaitingData(true);
        RequestUtils.getChallengePaged(
            pagedObject.searchTerm,
            pagedObject.page,
            pagedObject.itensPerPage,
            pagedObject.challengeIsActive
        ).then((res) => {
            if (res?.svStatus && res.data) {
                const data = res.data;
                setPagedObject({ ...pagedObject, amountPage: data.pageCount });
                setArrayChallenges(data.listChallenge);
            } else {
                snackbar(res.msg || "Não foi possível listar desafios.").error();
            }
            setAwaitingData(false);
        }).catch((e) => {
            snackbar("Erro ao listar desafios.").error();
            setAwaitingData(false);
        });
    }

    async function updateStatusChallenge(idChallengeUpdate) {
		setAwaitingData(true);
		RequestUtils.updateStatusChallenge(idChallengeUpdate).then((res) => {
			if (res?.svStatus && res.data) {
				let arr = arrayChallenges.filter((challenge) => {
					if (challenge?.idChallenge != idChallengeUpdate) return challenge;
				});
				setArrayChallenges(arr);
				snackbar("Status do desafio atualizado com sucesso.").success();
			} else {
				snackbar(res.msg || "Não foi possível atualizar status do desafio, verifique se esse desafios possui ou é sucessor de algum outro.").error();
			}
			setAwaitingData(false);
		}).catch((e) => {
			snackbar("Erro ao atualizar status do desafio.").error();
			setAwaitingData(false);
		});
	}

    function onPressButton() {
        const obj = { ...pagedObject, page: 1, searchTerm: inputValue };
        setPagedObject(obj);
        handlePagedChallenges(obj);
    }

    function handleChange(label, value) {
        let obj = pagedObject;

        switch (label) {
            case "searchTerm":
                setInputValue(value);
                if (value === "") obj = { ...obj, page: 1, searchTerm: value };
                break;
            case "challengeIsActive":
                obj = { ...obj, page: 1, challengeIsActive: value };
                break;
            default:
                break;
        }

        setPagedObject(obj);
        if (label !== "searchTerm" || value === "") handlePagedChallenges(obj);
    }

    function handleChangePage(event, value) {
        const obj = { ...pagedObject, page: value };
        setPagedObject(obj);
        handlePagedChallenges(obj);
    };

    return (
        <Page className={classes.root} title="Desafios">
            <Container maxWidth={false}>
                <Toolbar
                    inputValue={inputValue}
                    pagedObject={pagedObject}
                    onPressButton={onPressButton}
                    handleChange={handleChange}
                />
                {!awaitData ? (
                    <>
                        {arrayChallenges.length > 0 ? (
                            <>
                                <Box mt={3}>
                                    <Grid container spacing={3}>
                                        {arrayChallenges.map((challenge) => (
                                            <Grid item key={challenge.idChallenge} xs={12} md={6} lg={4}>
                                                <ChallengeCard
                                                    className={classes.challengeCard}
                                                    challenge={challenge}
                                                    updateStatusChallenge={updateStatusChallenge}
                                                />
                                            </Grid>
                                        ))}
                                    </Grid>
                                </Box>
                                <Box mt={3} display="flex" justifyContent="center">
                                    <Pagination
                                        color="primary"
                                        size="small"
										count={pagedObject.amountPage}
										page={pagedObject.page}
                                        onChange={handleChangePage}
                                    />
                                </Box>
                            </>
                        ) : (
                            <Box mt={3} display="flex" justifyContent="center">
                                <Typography variant="body1" gutterBottom color="primary">
                                    Nenhum item encontrado.
                                </Typography>
                            </Box>
                        )}
                    </>
                ) : (
                    <Box mt={3} display="flex" justifyContent="center">
                        <CircularProgress />
                    </Box>
                )}
            </Container>
        </Page>
    );
}

export default ChallengersList;